import React from "react";
import { CaseDocumentsHome } from "us.collection.documents/components";
interface ICnt_CaseDocuments {
  caseNo: number;
}

const Cnt_CaseDocuments: React.FC<ICnt_CaseDocuments> = (props) => {
  return <CaseDocumentsHome {...props}></CaseDocumentsHome>;
};

export default Cnt_CaseDocuments;
